import { Message } from 'view-design';

import axios from "axios";
import qs from "qs";

// 全局拦截配置
const axiosConfig = function () {
    axios.interceptors.request.use(function (config) {

        return Object.assign({}, config, {
            transformRequest: [function (data) {
                data = qs.stringify(data);
                return data;
            }]
        })
    })
    axios.interceptors.response.use((response) => {
        const res = response.data
        if(!res) {
            Message.destroy()
            setTimeout(() => {
                Message.error('出了点问题，请稍后重试')
            }, 10);
            return
        }
        if (res.stat == -1) {
            // 未登录重新登录
            window.location.href = res.data.url
        } else if (res.stat == 0) {
            Message.destroy()
            setTimeout(() => {
                Message.error(res.msg || '请求失败')
            }, 10);
        }
        return res
    }, (error) => {
        // Do something with response error 
        Message.destroy()
        setTimeout(() => {
            Message.error('出了点问题，请稍后重试')
        }, 10);
        return Promise.reject(error)
    })
}

export default axiosConfig


// WEBPACK FOOTER //
// ./pc/index/config/axios.js